import logger from "./logger";

export const updateStoryProgress = async (
  apiClient,
  userId,
  storyId,
  seconds,
  status = "IN_PROGRESS",
) => {
  if (!apiClient || !userId || !storyId) return false;

  const safeProgress = Math.max(0, Number(seconds) || 0);
  try {
    const response = await apiClient.updateStoryProgress(userId, {
      story_id: storyId,
      progress: safeProgress,
      status,
    });

    if (response?.success === false || response?.status === false) {
      logger.warn("⚠️ Story progress update failed", {
        storyId,
        safeProgress,
        status,
        error: response?.error,
      });
      return false;
    }
    return true;
  } catch (error) {
    logger.warn("⚠️ Story progress update error", {
      storyId,
      safeProgress,
      status,
      error,
    });
    return false;
  }
};

export const updateStorybookProgress = async (
  apiClient,
  userId,
  storybookId,
  pageIndex,
  status = "IN_PROGRESS",
) => {
  if (!apiClient || !userId || !storybookId) return false;

  const safeProgress = Math.max(0, Number(pageIndex) || 0);
  try {
    const response = await apiClient.updateStorybookProgress(userId, {
      storybook_id: storybookId,
      progress: safeProgress,
      status,
    });

    if (response?.success === false || response?.status === false) {
      logger.warn("⚠️ Storybook progress update failed", {
        storybookId,
        safeProgress,
        status,
        error: response?.error,
      });
      return false;
    }
    return true;
  } catch (error) {
    logger.warn("⚠️ Storybook progress update error", {
      storybookId,
      safeProgress,
      status,
      error,
    });
    return false;
  }
};
